<script setup>
const sections = ['Introduction', 'Air Pollutants',  'Sources', 'Effects','Origins', 'Actions', 'Benefits'];

const jumpToSection = (section) => {
    const el = document.getElementById(section.toLowerCase());
    if (el) {
        const top = el.offsetTop;
        document.documentElement.scrollTo({
            top: top,
            behavior: 'smooth'
        });
    }
};
</script>

<template>
    <nav>
        <ul>
            <li v-for="(section, index) in sections" :key="index">
                <button @click="jumpToSection(section)">
                    {{ section }}
                    <img src="diamond.svg" alt=""/>
                </button>
            </li>
        </ul>
    </nav>
</template>


<style lang="scss" scoped>
nav {
    position: fixed;
    right: 0;
    top: 50vh;
    transform: translateY(-50%);
    z-index: 100;
    text-align: right;

    ul {
        list-style: none;
        margin: 0;
        padding: 0 20px;

        li {

            button {
                color: #000;
                text-decoration: none;
                transition: all 0.2s ease-in-out;
                padding: 10px 20px;
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                line-height: 1;
                background: transparent;
                border: none;
                text-align: right;
                width: 100%;
                cursor: pointer;
                gap: 8px;

                img {
                    height: 8px;
                    transition: inherit;
                }
            }

            &:hover {
                button {
                    font-size: 130%;
                    height: 80px;
                    gap: 20px;
                    //padding-right: 30px;

                    img {
                        height: 12px;
                    }
                }
            }

            &:hover + li,
            &:has(+ li:hover) {

                button {
                    font-size: 110%;
                    height: 60px;
                    gap: 12px;
                    //padding-right: 25px;

                    img {
                        height: 10px;
                    }
                }
            }
        }
    }
}
</style>
